import { render, staticRenderFns } from "./StickyFooter.vue?vue&type=template&id=61353050&"
import script from "./StickyFooter.vue?vue&type=script&lang=js&"
export * from "./StickyFooter.vue?vue&type=script&lang=js&"
import style0 from "./StickyFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports